import { axios } from '@/lib/axios';
import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query';
import { useQuery, useSuspenseQuery } from '@tanstack/react-query';

import { Theme } from '../types';

export const getThemes = (): Promise<Theme[]> => {
  return axios.get('/api/v1/themes');
};

type QueryFnType = typeof getThemes;

type UseThemesOptions = {
  config?: QueryConfig<QueryFnType>;
};

export const useThemes = ({ config }: UseThemesOptions = {}) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['themes'],
    queryFn: () => getThemes(),
  });
};

export const useSuspenseThemes = ({ config }: UseThemesOptions = {}) => {
  return useSuspenseQuery<ExtractFnReturnType<QueryFnType>>({
    staleTime: 1000 * 60 * 10,
    ...config,
    queryKey: ['themes'],
    queryFn: () => getThemes(),
  });
};
